// 'use strict';

import $ from 'jquery';

// import selectize from 'selectize';
import chosen from 'chosen-js';

class BjzmFormScripts {

	constructor() {
		
		this.init();
		this.is_form_two_open = false;

	}

	init() {

		var self = this;
	
		self.doFormScripts();

		jQuery(document).bind('gform_post_render', function(e){

			self.doFormScripts();

			$(".gform_wrapper form").find('input[type="submit"]').removeClass('disabled');

			 if (!$(".gform_wrapper").hasClass("gform_validation_error")) {
			 	$("form input[type='text']").val('');
			 }
			
		});

	}

	do_terms_open() {

		 var self = this;

		$(".open-terms").on("click", function(e){
			e.preventDefault();
			$(".theme-lightbox--form").find(".mfp-close").trigger("click");

			var $termsLink = $(this);
			var isFormTwoTerms = $termsLink.hasClass("open-terms--form-2");
			var timeout = isFormTwoTerms ? 450 : 0;
			
		});
	}

	clearInputPlaceholders() {
		$('input,textarea').focus(function(){
			$(this).data('placeholder',$(this).attr('placeholder'))
			.attr('placeholder','');
		}).blur(function(){
			$(this).attr('placeholder',$(this).data('placeholder'));
		});
	}

	disableButtonOnSubmit() {
		$(".gform_wrapper form").on('submit', function(){
			$(this).find('input[type="submit"]').addClass('disabled');
		});
	}

	removeErrorClassOnFocus() {
		$(".gfield_contains_required.gfield_error").find('input[type="text"]').on('focus', function(){
			$(this).closest('.gfield_contains_required').removeClass('gfield_error');
		});
	}

	doFloatingLabels() {

		$(".gfield--floating-label input[type='text'], .gfield--floating-label textarea").each(function(){

			if( $(this).val() != '' ) {
				$(this).closest('.gfield--floating-label ').addClass('label-focused');
			}

		});

			/*registration floating Labels*/
		$(".gfield--floating-label input[type='text'], .gfield--floating-label textarea").focus(function(){
			 // console.log('hi');
			 $(this).closest('.gfield--floating-label').addClass('label-focused');
		}).blur(function(){
			if( $(this).val() == '' ) {
				$(this).closest('.gfield--floating-label').removeClass('label-focused');
			}
		});

	}

	doSelectInput() {

		$("select").chosen({disable_search_threshold: 10});

	}

	doFormScripts() {
		this.doSelectInput();
		this.doFloatingLabels();
		this.disableButtonOnSubmit();
		this.clearInputPlaceholders();
		this.removeErrorClassOnFocus();
		this.do_terms_open();
	}	

}


module.exports = BjzmFormScripts;